import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'sr-Latn';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3ihv1odb3qjic">
      <div lang="sr-Latn" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3ml1419v3fqjj">
        <CountdownBar data-id="element-2" data-mp="3rcj2nr9n9f1c" />
        <main data-id="element-3" data-mp="3rdas0kcnegj6">
          <Hero data-id="element-4" data-mp="3rcsy3udgkeef" />
          <StatsBar data-id="element-5" data-mp="3recerm310rgq" />
          <Difference data-id="element-6" data-mp="5yj0slx59ec" />
          <Recognize data-id="element-7" data-mp="6htxpd5ixiv" />
          <WhatsInside data-id="element-8" data-mp="4n53zyrel9i" />
          <InsidePages data-id="element-9" data-mp="56qjqnmbrsa" />
          <Bonuses data-id="element-10" data-mp="2zl3bdjx5744s" />
          <HowItWorks data-id="element-11" data-mp="2zllcouynw8jk" />
          <Audience data-id="element-12" data-mp="2zmepackaxs9m" />
          <Offer data-id="element-13" data-mp="2zmwguvw0rib7" />
          <Guarantee data-id="element-14" data-mp="2zng32ospcsv1" />
          <Testimonials data-id="element-15" data-mp="33mf623uvifju" />
          <Faq data-id="element-16" data-mp="33nq4do5juv3k" />
          <FinalCta data-id="element-17" data-mp="33n6yj5t6bx5w" />
        </main>
        <Footer data-id="element-18" data-mp="38lromcepp0gm" />
      </div>
    </MotionConfig>;
}